<template>
  <div id="HRChart">
    <header-top :headerText="headerText"></header-top>
    <main class="chart-main">
      <div class="tntry-trend">
        <div class="tntry-trend-tit">入离职趋势分析</div>
        <div class="search-filter">
          <el-button @click="setFilterDays(7)">近7天</el-button>
          <el-button @click="setFilterDays(30)">近30天</el-button>
          <el-date-picker
            align="center"
            v-model="query.dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
          <el-select v-model="query.org" clearable placeholder="选择部门">
            <el-option
              v-for="item in orgDic"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="tntry-trend-chart">
          <div id="tntryChart"></div>
        </div>
      </div>
      <div class="analysis-data">
        <div class="analysis-deatils education-info">
          <div class="title">学历分布排名</div>
          <el-table :data="education.education" style="width: 100%" header-align="center">
            <el-table-column label="排名" width="70" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.order }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="学历" min-width="70" align="center"></el-table-column>
            <el-table-column prop="number" label="人数" min-width="70" align="center"></el-table-column>
            <el-table-column prop="auditor" label="占比" min-width="70" align="center">
              <template slot-scope="scope">
                <span>{{ (scope.row.number/education.total*100).toFixed(2)| nullValue }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="analysis-deatils chart-example">
          <div class="title">招聘分销商分布</div>
          <div class="chart-box">
          <div id="chartChannel"></div>
          </div>
        </div>
        <div class="analysis-deatils">
          <div class="title">职务分布</div>
          <div class="chart-box">
          <div id="chartPost"></div>
          </div>
        </div>
        <div class="analysis-deatils">
          <div class="title">性别分布</div>
          <div class="chart-box">
          <div id="chartSex"></div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import echarts from "echarts";
export default {
  components: {
    headerTop
  },
  data() {
    return {
      headerText: "HR图表 V+",
      changeForm: [{}],
      orgDic: [
        {
          value: "人事",
          label: "人事"
        },
        {
          value: "法务",
          label: "法务"
        },
        {
          value: "财务",
          label: "财务"
        },
        {
          value: "信息",
          label: "信息"
        }
      ],

      query: {
        limit: 30,
        pageIndex: 1,
        dateRange: "",
        org: ""
      },
      tntryTrendData: [
        {
          date: "5月9日",
          entry: "110",
          quit: "140"
        },
        {
          date: "5月10日",
          entry: "20",
          quit: "190"
        },
        {
          date: "5月11日",
          entry: "35",
          quit: "111"
        },
        {
          date: "5月12日",
          entry: "80",
          quit: "140"
        },
        {
          date: "5月13日",
          entry: "120",
          quit: "10"
        },

        {
          date: "5月14日",
          entry: "12",
          quit: "10"
        },
        {
          date: "5月15日",
          entry: "120",
          quit: "102"
        },
        {
          date: "5月16日",
          entry: "130",
          quit: "140"
        },
        {
          date: "5月17日",
          entry: "10",
          quit: "10"
        },
        {
          date: "5月18日",
          entry: "50",
          quit: "15"
        },
        {
          date: "5月19日",
          entry: "120",
          quit: "100"
        },
        {
          date: "5月20日",
          entry: "0",
          quit: "100"
        },
        {
          date: "5月21日",
          entry: "120",
          quit: "100"
        },
        {
          date: "5月22日",
          entry: "120",
          quit: "10"
        },
        {
          date: "5月23日",
          entry: "120",
          quit: "100"
        },
        {
          date: "5月24日",
          entry: "120",
          quit: "100"
        },
        {
          date: "5月25日",
          entry: "120",
          quit: "100"
        },
        {
          date: "5月26日",
          entry: "1",
          quit: "18"
        },
        {
          date: "5月27日",
          entry: "120",
          quit: "89"
        },
        {
          date: "5月28日",
          entry: "120",
          quit: "100"
        },
        {
          date: "5月29日",
          entry: "120",
          quit: "100"
        },
        {
          date: "5月30日",
          entry: "120",
          quit: "190"
        },
        {
          date: "5月31日",
          entry: "120",
          quit: "100"
        },
        {
          date: "6月1日",
          entry: "60",
          quit: "80"
        },
        {
          date: "6月2日",
          entry: "130",
          quit: "70"
        },
        {
          date: "6月3日",
          entry: "120",
          quit: "100"
        },
        {
          date: "6月4日",
          entry: "60",
          quit: "80"
        },
        {
          date: "6月5日",
          entry: "130",
          quit: "70"
        },
        {
          date: "6月6日",
          entry: "95",
          quit: "140"
        },
        {
          date: "6月7日",
          entry: "80",
          quit: "100"
        },
        {
          date: "6月8日",
          entry: "150",
          quit: "90"
        },
        {
          date: "6月9日",
          entry: "100",
          quit: "130"
        }
      ],
      education: {
        total: 660,
        education: [
          {
            order: 1,
            name: "大专",
            number: 180
          },
          {
            order: 2,
            name: "本科",
            number: 130
          },
          {
            order: 3,
            name: "博士",
            number: 100
          },
          {
            order: 4,
            name: "其他",
            number: 100
          },
          {
            order: 5,
            name: "中专",
            number: 90
          },
          {
            order: 6,
            name: "高中",
            number: 30
          },
          {
            order: 7,
            name: "初中",
            number: 30
          }
        ]
      },
      channel: [
        { value: 335, name: "58同城" },
        { value: 310, name: "智联招聘" },
        { value: 234, name: "内部推荐" },
        { value: 135, name: "前程无忧" },
        { value: 200, name: "其他招聘网" },
        { value: 150, name: "分销商门店招聘" },
        { value: 236, name: "熟人介绍" },
        { value: 50, name: "人才市场招聘" },
        { value: 395, name: "校园招聘" },
        { value: 247, name: "其他" }
      ],
      post: [
        { value: 3, name: "经纪人" },
        { value: 2, name: "店经理" },
        { value: 5, name: "店长（股权合伙人）" },
        { value: 3, name: "区域总监" },
        { value: 6, name: "大区总监" },
        { value: 9, name: "管理员" },
        { value: 9, name: "人资经理" },
        { value: 2, name: "秘书部经理" },
        { value: 1, name: "分公司经理" },
        { value: 15, name: "店秘" }
      ],
      chartColor: [
        "#3AA1FF",
        "#36CBCB",
        "#4ECB73",
        "#FBD437",
        "#F2637B",
        "#5381F4",
        "#65C9D5",
        "#975FE5",
        "#FC9468",
        "#3A1CFF",
        "#A3A1FF"
      ]
    };
  },
  mounted() {
    this.tntryTrendChart(this.tntryTrendData);
    this.channelChart();
    this.postChart();
    this.sexChart();
  },
  methods: {
    tntryTrendChart(tntryTrendData) {
      var date = [],
        entry = [],
        quit = [];
      for (let tntryTrend of tntryTrendData) {
        date.push(tntryTrend.date);
        entry.push(tntryTrend.entry);
        quit.push(tntryTrend.quit);
      }

      let myChart = echarts.init(document.getElementById("tntryChart"));
      let option = {
        // title: {
        //   text: "折线图堆叠"
        // },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["离职人数", "入职人数"],
          x: "center", // 'center' | 'left' | {number},
          y: "bottom" // 'center' | 'bottom' | {number}
        },
        grid: {
          top:"20px",
          left: "0",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        toolbox: {
          right: "4%",
              bottom: "0%",
          feature: {
            saveAsImage: {
              
            }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        series: [
          {
            name: "离职人数",
            type: "line",
            data: entry,

            itemStyle: {
              normal: {
                color: "#0081FE", //改变折线点的颜色
                lineStyle: {
                  color: "#0081FE" //改变折线颜色
                }
              }
            }
          },
          {
            name: "入职人数",
            type: "line",
            data: quit,
            itemStyle: {
              normal: {
                color: "#21BE50", //改变折线点的颜色
                lineStyle: {
                  color: "#21BE50" //改变折线颜色
                }
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    channelChart() {
      let names = [];
      for (let name of this.channel) {
        names.push(name);
      }
      let myChart = echarts.init(
        document.getElementById("chartChannel")
      );
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: [
          {
            data: names.splice(0,names.length-6),
            bottom: 0,
            left: "center"
          },
          {
            data: names.splice(names.length-6,names.length),
            bottom: 20,
            left: "center"
          }      
        ],
        series: [
          {
            name: "招聘分销商分布",
            type: "pie",
            radius: ["50%", "65%"],
            center: ["50%", "45%"], // 饼图位置
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: this.channel,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.2)"
              },
              normal: {
                color: params => {
                  //自定义颜色
                  var colorList = this.chartColor;
                  return colorList[params.dataIndex];
                }
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    postChart() {
      let names = [];
      for (let name of this.post) {
        names.push(name);
        //console.log(name,5656);
        
      }
      let myChart = echarts.init(document.getElementById("chartPost"));
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: [
          {
            data: names.splice(0,names.length-6),
            bottom: 0,
            left: "center"
          },
          {
            data: names.splice(names.length-6,names.length),
            bottom: 20,
            left: "center"
          }
          
            // x: "center", // 'center' | 'left' | {number},
            // y: "bottom" // 'center' | 'bottom' | {number}
          //orient: "vertical",//数据信息
          
        ],
        series: [
          {
            name: "职务分布",
            type: "pie",
            radius: "65%",
            center: ["50%", "45%"], // 饼图位置
            avoidLabelOverlap: false,
            // label: {
            //   show: false,
            //   position: "center"
            // },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true
            },
            data: this.post,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.2)"
              },
              normal: {
                color: params => {
                  //自定义颜色
                  var colorList = this.chartColor;
                  return colorList[params.dataIndex];
                }
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    sexChart() {
      let myChart = echarts.init(document.getElementById("chartSex"));
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          data: ["男", "女", "保密"],
          bottom: 0,
          left: "center"
        },
        series: [
          {
            name: "性别分布",
            type: "pie",
            radius: "65%",
            center: ["50%", "45%"], // 饼图位置
            avoidLabelOverlap: false,
            // label: {
            //   show: false,
            //   position: "center"
            // },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true
            },
            data: [
              { value: 335, name: "男" },
              { value: 310, name: "女" },
              { value: 234, name: "保密" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.2)"
              },
              normal: {
                color: params => {
                  //自定义颜色
                  var colorList = [ "#39A1FF", "#F1637B","#4DCB73",];
                  return colorList[params.dataIndex];
                }
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },

    setFilterDays(num) {
      let start = new Date(new Date(new Date().setHours(0, 0, 0, 0)).getTime() - 24 * 60 * 60 * 1000 * num).toLocaleString(
          "chinese",
          { hour12: false }
        );
      let end = new Date().toLocaleString(
          "chinese",
          { hour12: false }
        );
      this.query.dateRange = [start, end];
      //console.log(this.query.dateRange);
      
      let tntryTrendData = this.tntryTrendData.slice(
        this.tntryTrendData.length - num - 1,
        this.tntryTrendData.length
      );
      this.tntryTrendChart(tntryTrendData);
    },
    handleCurrentChange(val) {
      //console.log("跳转的指定页", val);
      this.query.pageIndex = val;
    },
    handleSizeChange(val) {
      //console.log("更改的页面数量", val);
      this.query.limit = val;
    }
  }
};
</script>
<style scoped lang='scss'>
@import "../../../../styles/mixin.scss";
#HRChart {
  text-align: left;
  .chart-main {
    padding: 20px 20px 0;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    .tntry-trend {
      padding: 20px;
      background: #fff;
      box-shadow:0px 2px 3px 0px rgba(0, 0, 0, 0.2);
      .tntry-trend-tit {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 700;
        color: #000;
      }
      .search-filter {
        @include flex(row, flex-start);
        margin-bottom: 17px;
        height: 30px;

        .el-button {
          margin: 0;
          border-right-color: transparent;
          height: 30px;

          &:focus {
            border-right-color: $--color-primary;
          }
        }
        
        .el-select {
          margin-left: 10px;
          width: 95px;
        }
      }
      .tntry-trend-chart {
        #tntryChart {
          width: 100%;
          height: 400px;
        }
      }
    }
    .analysis-data {
      @include flex(row, center);
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 20px;
      
      .analysis-deatils {
        margin-bottom: 20px;
        padding: 25px 20px 50px;
        width: 46%;
        height: 410px;
        background: #fff;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
        .title {
          margin-bottom: 30px;
          font-size: 14px;
          font-weight: bold;
          color: #000;
        }
        #chartChannel,
        #chartPost,
        #chartSex {
          width: 588px;
          height: 350px;
        }
        .chart-box{
          width: 100%;
          height: 350px;
          @include flex(row,center);
            justify-content: center;
          #chartChannel{
            width: 588px;
          }
        }
      }
      .education-info{
        .title {
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>